import { render, staticRenderFns } from "./local_checklist.vue?vue&type=template&id=3143662b"
import script from "./local_checklist.vue?vue&type=script&lang=js"
export * from "./local_checklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports